import { render, staticRenderFns } from "./BankTransactionsSidebar.vue?vue&type=template&id=6923df6c&scoped=true&"
import script from "./BankTransactionsSidebar.vue?vue&type=script&lang=js&"
export * from "./BankTransactionsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactionsSidebar.vue?vue&type=style&index=0&id=6923df6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923df6c",
  null
  
)

export default component.exports